export function getCelloConfig() {
  const host = window.location.host;

  if (host === 'stage.dieter-datenschutz.de') {
    return {
      active: true,
      widgetLib: 'https://assets.sandbox.cello.so/app/latest/cello.js',
      attributionLib: 'https://assets.sandbox.cello.so/attribution/latest/cello-attribution.js',
    };
  } else if (host === 'app.dieter-datenschutz.de') {
    return {
      active: true,
      widgetLib: 'https://assets.cello.so/app/latest/cello.js',
      attributionLib: 'https://assets.cello.so/attribution/latest/cello-attribution.js',
    };
  }

  return {
    active: false,
    widgetLib: '',
    attributionLib: '',
  };
}
